/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import styles from '../../../styles/partials/menu.scss';

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string,
        label: PropTypes.string,
        current: PropTypes.bool,
    })),
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    currentClassName: PropTypes.string,
    linkClassName: PropTypes.string,
};

const defaultProps = {
    items: [],
    className: null,
    itemClassName: null,
    currentClassName: null,
    linkClassName: null,
};

const Menu = ({
    items, className, itemClassName, currentClassName, linkClassName,
}) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <ul className={styles.items}>
            {items.map(it => (
                <li
                    key={`item-${it.label}-${it.url}`}
                    className={classNames({
                        [styles.item]: true,
                        [itemClassName]: itemClassName !== null,
                        [styles.current]: it.current || false,
                        [currentClassName]: currentClassName !== null && (it.current || false),
                    })}
                >
                    {get(it, 'external', false) ? (
                        <a
                            href={it.url}
                            target={get(it, 'target', null)}
                            className={classNames({
                                [styles.link]: true,
                                [linkClassName]: linkClassName !== null,
                            })}
                        >
                            {it.label}
                        </a>
                    ) : (
                        <Link
                            to={it.url}
                            className={classNames({
                                [styles.link]: true,
                                [linkClassName]: linkClassName !== null,
                            })}
                        >
                            {it.label}
                        </Link>
                    )}
                </li>
            ))}
        </ul>
    </div>
);

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default Menu;



// WEBPACK FOOTER //
// ./js/components/partials/Menu.jsx